export function msToTime(duration) {
  if (duration <= 0) {
    return "--:--:--";
  }

  var seconds = Math.floor((duration / 1000) % 60),
    minutes = Math.floor((duration / (1000 * 60)) % 60),
    hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;

  return hours + ":" + minutes + ":" + seconds;
}

export function formatDate(date) {
  if (!date) return "-";
  return new Date(date).toISOString().split("T")[0];
}

export function formatDuration(minutes) {
  if (!minutes) return "-";
  return `${minutes} min`;
}
